export default "__VITE_ASSET__hhEA89tV__"